import { action, computed, flow, makeObservable, observable } from 'mobx'

import { requestWrapper } from 'Shared/utils'

import { ALL_OPTION } from 'Core/constants'
import { entityToLabelWithDashValue, getDefaultStoreArrayValue } from 'Core/utils'

import { ServiceSiteRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { BackupDocumentTable } from './BackupDocumentTable'

export class BackupDocumentStore {
	table: BackupDocumentTable
	@observable private accessor serviceSites = getDefaultStoreArrayValue<Entity>()

	constructor(private rootStore: RootStore) {
		this.table = new BackupDocumentTable(rootStore)
	}

	@computed
	get serviceSiteOptions(): LabelValue[] {
		const formatStatuses = this.serviceSites.value.map((status) =>
			entityToLabelWithDashValue(status)
		)

		return [ALL_OPTION, ...formatStatuses]
	}

	@flow.bound
	*retrieveServiceSites() {
		yield requestWrapper({
			field: this.serviceSites,
			repository: ServiceSiteRepo.retrieveServiceSites,
			repositoryParams: null
		})
	}

	@action
	clearServiceSites = () => {
		this.serviceSites = getDefaultStoreArrayValue<Entity>()
	}
}
